<template>
    <div>
        <section class="hc-geo is-loaded">
            <section class="hc-geo__region is-active">
                <section class="hc-section hc-section-green hc-static-testimonial__quote__container ">
                    <div class="search-bg">
                        <div class="bg-item animation1">
                            <img class="bg1" :src="bg_1" alt="">
                        </div>
                        <div class="bg-item animation2">
                            <img class="bg1" :src="bg_1" alt="">
                        </div>
                    </div>
                    <div class="hc-cntr hc_container_mobile_np">
                        <div class="hc-cntr-lt">
                            <img class="banner" :src="waitress" alt=""></img>
                        </div>
                        <div class="hc-cntr-rt hc_container_mobile_np">
                            <div class="title">
                                <p class="t-disp-2 cn-title">{{ $t('searchJob.bigTitle') }}</p>
                                <p class="cn-sub-title">{{ $t('searchJob.titleDesc1') }}</p>
                            </div>
                            <div class="search">
                                <div class="search-input">
                                    <label for="">{{ $t('searchJob.search') }}</label>
                                    <input v-model="keyWords" type="text" @keyup.enter="handleSearch"
                                        :placeholder="$t('searchJob.searchPlaceholder')">
                                </div>
                                <div v-if="device === 'pc'" class="search-icon" @click="handleSearch">
                                    <img width="24" height="24" :src="search_icon" alt="">
                                </div>
                                <div v-else class="search-icon" @click="goSearchJobResult">
                                    <img width="24" height="24" :src="search_icon" alt="">
                                </div>
                            </div>
                        </div>
                        <section v-if="device === 'mb'" class="hc-filter_mb" @click="goSearchJobResult">
                            <div class="filter-item-title">
                                <span>
                                    {{ $t('searchJob.allJob') }} {{ jobCount }}
                                </span>
                            </div>
                            <div class="filter-item-arrow">
                                <img :src="down_arrow_w" alt="" width="16" height="16" />
                            </div>
                        </section>
                    </div>
                </section>
            </section>
        </section>

        <section class="hc-geo is-loaded" v-if="device === 'pc'">
            <section class="hc-geo__region is-active">
                <section class="hc-section hc-static-testimonial__quote__container hc-section-white-200">
                    <div class="hc-filter-list">
                        <div class="hc-filter">
                            <div class="filter-left">
                                <div class="filter-item-title">
                                    <span>
                                        {{ $t('searchJob.allJob') }} {{ jobCount }}
                                    </span>
                                </div>
                            </div>
                            <div class="filter-right">
                                <div class="item-list">
                                    <Popover close-on-click-outside v-model:show="searchItem.showPopover"
                                        placement="bottom-start" :key="index" :show-arrow="false"
                                        v-for="(searchItem, index) in searchList">
                                        <MySelects :searchItem="searchItem" @confirmSelect="confirmSelect(searchItem)"
                                            @resetFilter="() => { resetFilter (index)}">
                                        </MySelects>
                                        <template #reference>
                                            <div @click="(e) => { changeFilter(e, index) }"
                                                :class="`filter-item ${searchItem.showPopover && 'checked'}`">
                                                <span class="filter-text">
                                                    {{ searchItem.filterName }}
                                                    <span class="filter-number"
                                                        v-if="searchItem.selectedCode.allValue.length">
                                                        {{ searchItem.selectedCode.allValue.length }}
                                                    </span>
                                                </span>
                                            </div>
                                        </template>
                                    </Popover>
                                </div>
                                <div class="filter-icon-list">
                                    <div v-if="filterType === 'list'" class="filter-date" @click="changeSortType">
                                        <span>
                                            {{ $t('searchJob.releaseDate') }}
                                        </span>
                                        <img :class="`filter-date-icon ${sortType === 2 ? 'sort' : ''}`" width="28"
                                            height="28" :src="sortType === null? sort_default_icon : sort_icon" alt="">
                                    </div>
                                    <div class="filter-right-types">
                                        <div @click="changeType('list')"
                                            :class="`filter-type  ${filterType === 'list' && 'checked'}`">
                                            <img width="28" height="28" :src="list_icon" alt="">
                                        </div>
                                        <div @click="changeType('location')"
                                            :class="`filter-type  ${filterType === 'location' && 'checked'}`">
                                            <img width="28" height="28" :src="location_icon" alt=""></img>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <jobList v-if="filterType === 'list' && jobListData.length > 0" :jobList="jobListData"
                            :jobDetail="jobDetail" @getJobDetail="getJobDetail" @clearDetail="clearDetail">
                            <div class="list-pagination" v-if="jobCount">
                                <span>{{ $t('searchJob.total') }}  <span style="font-weight: 600;">{{ Math.ceil(jobCount / listLimit) }}</span> {{ $t('searchJob.page') }} </span> 
                                <span v-if="locale === 'en'">&nbsp;</span><span> {{ $t('searchJob.currentPage') }}  <span style="font-weight: 600;">{{ currentPageNum }}</span>  {{ $t('searchJob.entries') }}</span>
                                <Pagination v-model="currentPage" @change="changePageNumber" :total-items="jobCount"
                                    :show-page-size="7" :force-ellipses="false">
                                    <template #prev-text>
                                        <Button :class="`pagination-btn ${locale === 'en' ? 'pagination-btn-en' : ''}`" color="#c028b9" type="primary"> {{ $t('searchJob.previousPage') }}</Button>
                                    </template>
                                    <template #next-text>
                                        <Button :class="`pagination-btn ${locale === 'en' ? 'pagination-btn-en' : ''}`" color="#c028b9" type="primary"> {{ $t('searchJob.nextPage') }}</Button>
                                    </template>
                                </Pagination>
                            </div>
                        </jobList>
                        <Overlay :show="loadingFlag" :z-index="1" :duration="0" :lock-scroll="true">
                            <div class="over-loading">
                                <Loading class="loading" type="spinner" color="#fff" size="40" />
                            </div>
                        </Overlay>
                        <NoJob v-if="filterType === 'list' && jobListData.length === 0 && !loadingFlag"></NoJob>
                        <JobMap v-if="filterType === 'location'" :markers="jobListMapData" :jobDetail="jobDetail"
                            @getJobDetail="getJobDetail" @clearDetail="clearDetail"></JobMap>
                    </div>
                </section>
            </section>
        </section>
    </div>
</template>

<script setup>
import search_icon from '@/assets/image/searchJob/search_icon.png'
import bg_1 from '@/assets/image/searchJob/bg-1.png'
// import bg_2 from '@/assets/image/searchJob/bg-2.png'
import waitress from '@/assets/image/home/hilton-china-cocktail-waitress-2.png'
import sort_icon from '@/assets/image/searchJob/sort-icon.png'
import sort_default_icon from '@/assets/image/searchJob/sort-default-icon.png'
import list_icon from '@/assets/image/searchJob/list-icon.png'
import location_icon from '@/assets/image/searchJob/location-icon.png'
import down_arrow_w from '@/assets/image/searchJob/down-arrow-w.png'
import { inject } from 'vue'
import '@vant/touch-emulator';
import { Popover, Pagination, Button, Overlay, Loading } from 'vant';
import MySelects from '@/components/MySelects.vue'
import jobList from './components/jobList.vue'
import JobMap from './components/jobMap2.vue'
import NoJob from './components/noJob.vue'
import useJobList from './useJobList.js'
const device = inject("device");
const { 
    locale,
    searchList, 
    jobDetail,
    currentPage,
    currentPageNum,
    loadingFlag,
     keyWords, 
     jobCount, 
     jobListData, 
    jobListMapData,
     sortType, 
     filterType, 
     changeFilter, 
     resetFilter, 
     changeSortType, 
     changeType, 
     handleSearch, 
    clearDetail,
    getJobDetail,
    confirmSelect,
    goSearchJobResult,
    changePageNumber,
    listLimit } = useJobList()

</script>

<style lang='scss' scoped>
.hc-section-green {
    background-color: #06937E;
}

.hc-section-white-200 {
    background-color: var(--hc-color--offwhite-200);
}

.hc-cntr {
    position: sticky !important;
    top: 0;
    width: 100%;
    overflow: hidden;
    display: flex;
    padding: 160px 0 0;

    &-lt { 
        flex: 1;

        .banner {
            display: block;
            width: 590px;
            height: 576px;
        }
    }

    &-rt {
        width: 45%;
        box-sizing: border-box;
        padding: 80px 44px 0;
        background-color: #FBF9F9;
    }

    .cn-title {
        // width: 28rem;
        margin-bottom: 24px;
    }

    .cn-sub-title {
        margin-bottom: 88px;
        font-family: var(--hc-font--headline);
        color: #002F61;
        font-weight: 400;
        font-size: 1.75rem;
    }

    .title {
        max-width: 610px;
        font-weight: 400;
    }

    .search {
        display: flex;
        border-radius: 4px;
        justify-content: space-between;
        background-color: #fff;

        .search-input {
            border: 1px solid rgba(0, 47, 97, 0.2);
            border-right: unset;
            width: 100%;
            padding: 16px 32px 4px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            border-radius: 4px;
            overflow: hidden;

            label {
                font-size: 0.825rem;
            }

            input {
                font-size: 1rem;
                border: none;
                height: 100%;
                width: 100%;
                line-height: 1.5rem;
                background-color: #fff;
                color: #000000;
                transition: all 0.3s ease;
                &:focus::placeholder {
                    opacity: 0.3;
                }
            }
        }

        .search-icon {
            cursor: pointer;
            width: 88px;
            height: 88px;
            border: 1px solid rgba(0, 47, 97, 0.2);
            border-left: unset;
            flex: none;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: var(--hc-color--bright-purple);
            transition: all 0.3s ease;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;

            &:hover {
                opacity: 0.8;
            }
        }
    }
}

.over-loading{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

@media (min-width: 1070px) {
  .hc-section {
    padding-inline: 0px;
  }
}

@media (min-width: 1260px) {
    .hc-section {
        padding-inline: 89px;
    }
}

@media (max-width: 1070px) {
    .hc-section-green {
        min-height: calc(100vh - 70px);
    }

    .hc-cntr {
        padding-top: 82px;
        flex-direction: column;

        &-lt { 
            .banner {
                width: 100%;
                height: auto;
            }
        }

        &-rt {
            margin-top: -36vw;
            padding: 56px 0;
            width: 100%;
        }

        .cn-title {
            width: 100%;
        }

        .cn-sub-title {
            margin-bottom: 56px;
            font-size: 1.2rem;
        }

        .title {
            width: 100%;
            max-width: 100%;
            text-align: center;
        }

        .search {
            width: 100%;
            flex-direction: column;
            padding: 0 20px;
            .search-input {
                border-radius: 2px;
                border-right: 1px solid rgba(0, 47, 97, 0.2);
                padding: 12px 20px;
                input {
                        margin-top: 8px;
                    }
            }

            .search-icon {
                margin-top: 10px;
                width: 100%;
                height: 48px;
                    border-radius: 2px;
                border: unset;
            }
        }
    }
}

@media (max-width: 767px) {
    // // 手机端清除padding
    .hc_container_mobile_np {
        padding-inline: 0px !important;
    }
}

.search-bg {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 0;
    overflow: hidden;

    .bg-item {
        display: flex;
        overflow: hidden;

        img {
            width: 66%;
        }
    }

    .animation1 {
        animation: marquee 40s linear infinite;
    }

    .animation2 {
        animation: marquee reverse 40s linear infinite;
    }

    /* 动画定义 */
    @keyframes marquee {
        0% {
            transform: translateX(100%);
        }

        100% {
            transform: translateX(-100%);
        }
    }

}

@media (max-width: 1439px) {
    .search-bg {
        .bg-item {
            img {
                width: 80%;
            }
        }
    }
}

@media (min-width: 1024px) {
    .t-disp-2 {
        font-size: 4rem;
    }
}

@media (max-width: 1070px) {
    .search-bg {
        .bg-item {
            img {
                width: 120%;
            }
        }
    }
}

@media (max-width: 767px) {
    .search-bg {
        bottom: 44px;

        .bg-item {
            img {
                width: 260%;
            }
        }
    }
}



.hc-filter_mb {
    position: relative;
    z-index: 9;
    padding: 2em 0 0;
    color: #fff;
    text-align: center;
    font-size: 1rem;
    font-weight: 500;

    .filter-item-arrow {
        margin-top: 12px;
    }
}

.filter-item-title {
    font-weight: 600;
}

.hc-filter-list {
    width: 80%;
    margin: auto;
    padding-top: 32px;
    padding-bottom: 180px;

    .hc-filter {
        padding: 24px;
        display: flex;
        justify-content: space-between;
        background-color: #fff;
        border-radius: 4px;
    }

    .filter-left {
        .filter-item-title {
            padding: 10px 0 10px 16px;
            color: rgba(0, 0, 0, 1);
            height: 44px;
            font-size: 1.125rem;
            font-weight: 600;
            display: flex;
            align-items: center;
            &::after {
                content: "";
                display: block;
                width: 1px;
                height: 14px;
                margin-left: 16px;
                background-color: rgba(0, 0, 0, 1);
            }
        }
    }

    .filter-right {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: rgba(0, 0, 0, 1);
        height: 44px;

        .item-list {
            padding: 12px 0;
            display: flex;
            flex: 1;
            width: 0;
            overflow: auto;
            -webkit-overflow-scrolling: touch;
        }

        .filter-item {
            padding: 10px 16px;
            color: rgba(0, 0, 0, 1);
            height: 44px;
            cursor: pointer;

            .filter-text {
                display: flex;
                align-items: center;
                white-space: nowrap;

                .filter-number {
                    font-size: 0.75rem;
                    background-color: var(--hc-color--bright-purple);
                    color: var(--hc-color--white);
                    width: 1rem;
                    height: 1rem;
                    border-radius: 0.5rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-left: 4px;
                }
            }

            .filter-text::after {
                content: "";
                width: 16px;
                height: 16px;
                margin-left: 8px;
                display: block;
                background-repeat: no-repeat;
                background-position: 50%;
                background-image: url('/src/assets/image/searchJob/down-arrow.png');
                background-size: cover;
                transition: all .3s;
            }
        }

        .filter-item.checked {
            background-color: rgba(240, 233, 230, 1);
            color: rgba(0, 47, 97, 1);
            border-bottom: 2px solid var(--hc-color--bright-purple);

            .filter-text::after {
                transform: rotate(180deg)
            }
        }

        .filter-icon-list {
            display: flex;

            .filter-date {
                display: flex;
                align-items: center;
                padding-left: 16px;

                .filter-date-icon {
                    margin-left: 8px;
                    cursor: pointer;
                    transition: all .3s;
                }
                                .filter-date-icon.sort{
                                    transform: rotate(180deg);
                                }
            }

            .filter-right-types {
                display: flex;
                align-items: center;
                border: 1px solid rgba(0, 47, 97, 0.2);
                margin-left: 24px;
                border-radius: 4px;

                .filter-type {
                    display: flex;
                    align-items: center;
                    padding: 8px 8px;
                    cursor: pointer;
                }

                .filter-type.checked {
                    background-color: rgba(0, 47, 97, 0.1);
                }
            }
        }




    }
    .list-pagination{
        margin-top: 20px;
        margin-right: 26px;
        display: flex;
        justify-content: end;
        align-items: center;
        .pagination-btn{
            padding: 0 16px;
            height: 34px;
            // width: 74px;
        }
        .pagination-btn-en{
            width: 120px;
        }
        .van-pagination {
            background-color: #fff;
           padding: 0px 6px;
           border-radius: 4px;
        }
        .next-block{
            display: flex;
        }
        ::v-deep(.van-pagination__item){
            cursor: pointer;
            border-radius: 4px;
        }
                 ::v-deep(.van-pagination__item button) {
                     cursor: pointer;
                 }
        
        ::v-deep(.van-pagination__item:active){
            background-color: #c028b9;
                button {
                    color: #fff;
                }
        }
        ::v-deep(.van-pagination__item:hover) {
                      background-color: #c028b9;
                      button {
                         color: #fff;
                      }
        }
        ::v-deep(.van-pagination__item--active) {
                         background-color: #c028b9;
                         button{
                            color: #fff;
                         }
         }
       
    }
}

@media (max-width: 1070px) {
    .hc-filter-list {
        width: 100%;
    }

    .hc-filter {
        flex-direction: column;

        .filter-item-title {
            justify-content: center;
        }
    }
}

@media (max-width: 767px) {
    .hc-filter-list {
        .filter-right {
            display: none;
        }

    }
}
</style>
<style lang="scss">
.van-popover__content--vertical {
    border-radius: 0;
}
</style>
